import { parse, stringify } from 'qs';
import { push } from 'connected-react-router';

import * as actions from './actions';
import * as selectors from './selectors';

import { operations } from './index';

export const getQueryFromURL = () => (dispatch, getState) => {
  const { search: searchParams } = selectors.location(getState());
  if (!searchParams) {
    return Promise.resolve();
  }
  // by default maximum array length is 20
  // Any array members with index greater than limit will be converted to an object
  const parsedSearchParams = parse(searchParams, { ignoreQueryPrefix: true, arrayLimit: 100 });
  return dispatch(actions.changeUrlQueryToFilter(parsedSearchParams));
};

export const updateURLWithQuery = () => (dispatch, getState) => {
  const query = selectors.getQuerySelector(getState());
  return dispatch(push({ search: stringify(query) }));
};

export const fetchFilters = () => (dispatch, getState) => {
  const params = selectors.fetchFiltersQuerySelector(getState());
  return dispatch(actions.fetchFilters(params));
};

export const updateFilter = (payload) => (dispatch) => (
  Promise.all([
    dispatch(actions.changePage(1)),
    dispatch(actions.updateFilter(payload)),
  ]).then(() => dispatch(operations.updateURLWithQuery()))
);

export const initialize = () => (dispatch) => (
  Promise.all([
    dispatch(operations.fetchFilters()),
    dispatch(actions.getUsers()),
    dispatch(actions.getTeams()),
  ]).then(() => dispatch(operations.getQueryFromURL()))
);
